<mat-card>
  <mat-card-header>
    <div class="card-status">
      <div class="card-status__right">
        <img src="{{ cardData.topHeaderIcon }}" width="23" height="23" *ngIf="cardData.topHeaderIcon" />
        <span class="header-text" *ngIf="cardData.topHeaderText">{{ cardData.topHeaderText }}</span>
        <span class="top-one-bubble-text" *ngIf="cardData.topBubble1Text">{{ cardData.topBubble1Text }}</span>
        <span class="top-two-bubble-text" *ngIf="cardData.topBubble2Text">
          <img
            src="{{ cardData.topBubble2Icon }}"
            alt=""
            width="23"
            height="23"
            *ngIf="cardData.topBubble2Icon"
          />
          {{ cardData.topBubble2Text }}
        </span>
      </div>
      <div class="card-status__left" *ngIf="cardData.topLeftBubbleText">
        <span>{{ cardData.topLeftBubbleText }}</span>
      </div>
    </div>
  </mat-card-header>
  <mat-card-content>
    <div class="top-catalog-card">
    <mat-card-title>
      {{ cardData.title }}
    </mat-card-title>
    <button
      class="button button--favorite"
      (click)="onFavoriteClick($event)"
      [class.active]="cardData.isFavorite"
      [attr.aria-pressed]="cardData.isFavorite"
      [attr.data-id]="cardData?.nodeId"
      type="button"
    >
      <svg
        width="26"
        height="26"
        viewBox="0 0 23 24"
        xmlns="http://www.w3.org/2000/svg"
        role="img"
        aria-hidden="true"
      >
        <path
          d="M11.9417 17.7293L5.49256 21.125L6.7245 13.9328L1.5 8.83982L8.70981 7.79338L11.9344 1.25L15.1589 7.79338L22.3688 8.83982L17.1442 13.9328L18.3762 21.125L11.9417 17.7293Z"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        ></path>
      </svg>
    </button>
    </div>
    <div class="filters catalog-filter-list">
      <div class="filter" *ngFor="let filter of cardData.filters">
        {{ filter.Value }}
      </div>
    </div>
    <div class="card-description">
      {{ cardData.description }}
    </div>
    <div *ngIf="checkIfContactInfoExists()" class="card-contact-info">
      <div *ngIf="cardData.fullName" class="card-contact-info-name">
        {{ cardData.fullName }}<span *ngIf="cardData.role" class="card-contact-info-role">, {{cardData.role}}</span>
        <span *ngIf="cardData.email" class="data-info">
          <span class="d-phone-none">,</span>
          <img src="Content/Images/icons/email.svg" width="32" height="32" />
          <a href="mailto:{{ cardData.email }}">
            {{ cardData.email }}
          </a>
        </span>
        <span *ngIf="cardData.phone" class="data-info">
          <span class="d-phone-none">,</span>
          <img src="Content/Images/icons/phone.svg" width="32" height="32" />
          <a href="tel:{{ cardData.phone }}">
            {{ cardData.phone }}
          </a>
        </span>
      </div>
    </div>
  </mat-card-content>
  <mat-card-footer>
    <a *ngIf="cardData.link" href="{{ cardData.link.url }}" :target="cardData.link.target" class="link card-link">
      <div class="link-text">{{ cardData.link.title }}</div>
      <div class="link-arrow">
        <img
          src="/Content/Images/icons/arrow-down.svg"
          width="18"
          height="12"
        />
      </div>
    </a>
  </mat-card-footer>
</mat-card>
